import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPurely',
    standalone: false
})
export class FilterPurelyPipe implements PipeTransform {
  transform(items: any[], filterFn: (i: any) => boolean): any[] {
    if (!items) return [];
    if (!filterFn) return items;

    return items.filter(filterFn);
  }
}
